__turbopack_context__.v({
  "disabled-text-border": "styles-module__4ZhBqW__disabled-text-border",
});
